import Component from './TreeHeader.component';

export default Component;
